<div class="popup-backdrop" (click)="PopupEvent('close')"  *ngIf="popup?.Display">
</div>
<div class="popup-component" *ngIf="popup?.Display" >

  <div class="popup-container service-setup-popup patient-setup-popup" style=" text-wrap: nowrap;">
    <div class="popup-content">
      <!-- popup header -->
      <div class="popup-header">
        <h2>{{ popup?.Title }}</h2>
      </div>
      <!-- popup body - content view -->
      <div class="popup-body">
        <div class="column gap-30">
          <div class="row gap-30 justify-space-between">
            <div class="title">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.7116 21.2142C20.0518 19.1569 18.7558 17.3623 17.0106 16.0891C15.2651 14.8159 13.1605 14.1299 11.0001 14.1299C8.83971 14.1299 6.73511 14.8159 4.98974 16.0891C3.24439 17.3623 1.94842 19.1569 1.2887 21.2142H20.7116Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11 14.1428C14.6729 14.1428 17.6504 11.1653 17.6504 7.49241C17.6504 3.81951 14.6729 0.842041 11 0.842041C7.32709 0.842041 4.34961 3.81951 4.34961 7.49241C4.34961 11.1653 7.32709 14.1428 11 14.1428Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.1717 10.0657C13.1717 10.0657 12.6199 11.1514 11.0002 11.1514C9.38042 11.1514 8.82861 10.0657 8.82861 10.0657" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M17.5299 6.22623C17.515 6.22632 17.5002 6.22637 17.4855 6.22637C15.5523 6.22637 13.8168 5.38064 12.6286 4.03902C11.4404 5.38067 9.70486 6.22642 7.77177 6.22642C6.64923 6.22642 5.5933 5.94122 4.67249 5.43934C5.53762 2.77119 8.04347 0.842041 10.9999 0.842041C14.2398 0.842041 16.9386 3.15891 17.5299 6.22623Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h3 *ngIf="popup?.PopupAction == 'Administration'">ADMINISTRATION BY:</h3>
              <h3 *ngIf="popup?.PopupAction == 'Leave'">LEAVE FOR:</h3>
            </div>
            <div class="form-group">
              <app-custom-dropdown [options]="staffList"
                                   [placeholder]="'Select an option'"
                                   [(ngModel)]="selectedStaff"
                                   [optionsText]="'FullName'"
                                   [optionsValue]="'ID'">
              </app-custom-dropdown>

            </div>
          </div>
          <!-- Administration Type-->
          <div class="column gap-30" *ngIf="popup?.PopupAction == 'Administration'">
            <div class="row gap-30 justify-space-between">
              <div class="form-group ">
                <label>Type of Administration</label>
                <app-custom-dropdown [options]="appointmentTypes"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="selectedAppointmentType"
                                     [optionsText]="'Description'"
                                     [optionsValue]="'ID'">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="row gap-30 justify-space-between">
              <div class="form-group">
                <label>Date</label>
                <app-calendar-dropdown [(selectedDate)]="schedule.DateFron"></app-calendar-dropdown>
              </div>
              <div class="form-group">
                <label><span *ngIf="timeError == true" class="error-popup">*</span>Start from</label>
                <app-custom-dropdown [options]="times"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="selectedStartTime"
                                     [optionsText]="'Type'"
                                     [optionsValue]="'Type'"
                                     (ngModelChange)="TimeSelectionValidation()">
                </app-custom-dropdown>

              </div>
            </div>
            <div class="row gap-30 justify-end text-transform-none">
              <div class="form-group">
                <label>Duration</label>
                <app-custom-dropdown [options]="durations"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="duration"
                                     [optionsText]="'Description'"
                                     [optionsValue]="'Description'"
                                     (ngModelChange)="selectDuration()"
                                     textSuffix="min">
                </app-custom-dropdown>
              </div>
            </div>
            <p class="error-popup">*Administration is limited to 1 hour per day</p>
          </div>
          <!---->
          <!-- LEAVE Type -->
          <div class="column gap-20" *ngIf="popup?.PopupAction == 'Leave'">
            <div class="row gap-30">
              <div class="form-group ">
                <label>Type of Leave</label>
                <app-custom-dropdown [options]="appointmentTypes"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="selectedAppointmentType"
                                     [optionsText]="'Description'"
                                     [optionsValue]="'ID'">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="row gap-30">
              <div class="form-group">
                <label>Date From</label>
                <app-calendar-dropdown [(selectedDate)]="schedule.DateFron"></app-calendar-dropdown>
              </div>
              <div class="form-group" *ngIf="schedule.DayOption != 'halfDay'">
                <label>Date To</label>
                <app-calendar-dropdown [(selectedDate)]="schedule.DateTo"></app-calendar-dropdown>
              </div>
            </div>
            <div class="row gap-30" *ngIf="!schedule.DayOption">
              <div class="form-group">
                <label><span *ngIf="timeError == true" class="error-popup">*</span>Time from</label>
                <app-custom-dropdown [options]="times"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="selectedStartTime"
                                     [optionsText]="'Type'"
                                     [optionsValue]="'Type'"
                                     (ngModelChange)="TimeSelectionValidation()">
                </app-custom-dropdown>
              </div>
              <div class="form-group">

                <label><span *ngIf="timeError == true" class="error-popup">*</span>Time To</label>
                <app-custom-dropdown [options]="times"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="selectedEndTime"
                                     [optionsText]="'Type'"
                                     [optionsValue]="'Type'"
                                     (ngModelChange)="TimeSelectionValidation()">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="column" *ngIf="timeError == true">
              <span class="error-message">* Start time must be before end time.</span>
            </div>
            <div class="row gap-30">
              <div class="form-group">
                <label for="halfDay" class="checkbox-control">
                  Half Day (Saturday)
                  <input type="radio"
                         id="halfDay"
                         name="dayOption"
                         [(ngModel)]="schedule.DayOption"
                         (change)="ifHalfDay()"
                         value="halfDay" />
                  <span class="checkbox-indicator"></span>
                  <span class="checkbox-indicator-container"></span>
                </label>
              </div>
              <div class="form-group">
                <label for="fullDays" class="checkbox-control">
                  Full Day(s)
                  <input type="radio"
                         id="fullDays"
                         name="dayOption"
                         [(ngModel)]="schedule.DayOption"
                         (change)="ifFullDay()"
                         value="fullDays" />
                  <span class="checkbox-indicator"></span>
                  <span class="checkbox-indicator-container"></span>
                </label>
              </div>
            </div>
            <p class="error-popup">Remember your leave on ESS <strong style="text-transform: uppercase">*This is not a leave request</strong></p>
          </div>
        </div>
        <div class="popup-buttons">
          <button type="button" (click)="generateMeeting()" class="popup-btn">{{ popup?.Button?.ButtonText || 'Close' }}</button>
          <button type="button" *ngIf="popup?.AltButton?.ButtonText" (click)="AltButtonClick()" class="popup-btn">{{ popup?.AltButton?.ButtonText }}</button>
        </div>
      </div>
      

    </div>
  </div>
</div>
